import React from 'react'
import {Link} from 'react-router-dom'
import {PushClientDTO} from 'grilnica-store-share'
import {formatDate} from 'grilnica-share'

interface NotificationListItemProps {
  message: PushClientDTO
  className?: string
}

const NotificationListItem: React.FC<NotificationListItemProps> = ({
  message,
  className,
}): React.ReactElement => {
  const isRead = !!message.readDate
  const isHidden = message.isHidden
  return (
    <Link to={'/notifications/' + message.pushQueueId}>
      <div className={'notification-list-item ' + (className ? className : '')}>
        <p
          className={'notification-list-item-name ' + (isHidden ? 'hidden' : !isRead ? 'new' : '')}>
          {message.title}
        </p>
        <p className={'notification-list-item-date'}>{formatDate(message.factSendTime)}</p>
      </div>
    </Link>
  )
}

export {NotificationListItem}
